import { Get, Post, Delete, Put, Patch } from '../../api/axiosCoreConfig';
import { createQueryParamsFromObject } from '../../api/helper';

const validate = process.env.REACT_APP_VALIDATION;

export const createNewFormStructure = (form) => Post(`/form/f`, form);
export const getForms = (namespace, params) =>
    Get(`/form/f?namespace=${namespace}`, { params: createQueryParamsFromObject(params) });
export const deleteForm = (formName, namespace) =>
    Delete(`/form/f/${formName}?namespace=${namespace}`);
export const getSubjects = (namespace) => Get(`/form/subject_key?namespace=${namespace}`);
export const getFormStructure = (formName, namespace) =>
    Get(`/form/f/${formName}?namespace=${namespace}`);
// export const getFormEntries = (formName, params) =>
//     Get(`/form/f/${formName}/entry`, { params: createQueryParamsFromObject(params) });
export const getFormEntries = (params) =>
    Get(`/form/f/entry`, { params: createQueryParamsFromObject(params) });
export const filterFormEntries = (formName, params) =>
    Get(`/form/f/${formName}/entry`, { params: createQueryParamsFromObject(params) });
export const createFormEntry = (formName, form) =>
    Post(`/form/f/${formName}/entry${validate ? `?validate=${validate}` : ''}`, form);
export const editFormEntry = (formName, formEntryId, form) =>
    Put(`/form/f/${formName}/entry/${formEntryId}${validate ? `?validate=${validate}` : ''}`, form);
export const deleteFormEntry = (formName, formEntryId, namespace) =>
    Delete(`/form/f/${formName}/entry/${formEntryId}?namespace=${namespace}`);
export const createFormReport = (formName, params) =>
    Post(`/form/f/${formName}/export/xlsx`, params);
// export const deleteFormReport = (formName) => Delete(`/form/f/${formName}/export/xlsx`);
export const editForm = (formName, content) => Patch(`/form/f/${formName}`, content);
export const sortForms = (namespace, forms) => Patch(`/form/f?namespace=${namespace}`, { forms });

export const uploadMedia = (formName, file) => Post(`/form/f/${formName}/entry_file`, file);
export const deleteFormExport = (formName, namespace) =>
    Delete(`form/f/${formName}/export/xlsx?namespace=${namespace}`);
export const getFormExportFile = (formName) =>
    Get(`/form/f/${formName}/export/xlsx/file`, { responseType: 'blob' });
